import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const PencilEdit = createIcon({
  displayName: 'PencilEdit',
  viewBox: '0 0 18 16',
  path: [
    <path
      d="M15.71 2.63C16.1 3.02 16.1 3.65 15.71 4.04L13.88 5.87L10.13 2.12L11.96 0.29C12.15 0.0999999 12.41 0 12.66 0C12.92 0 13.17 0.0900002 13.37 0.29L15.71 2.63Z"
      key="PencilEdit1"
    />,
    <path
      clipRule="evenodd"
      d="M9.06 3.18994L0 12.2499V15.9999H3.75L12.81 6.93994L9.06 3.18994ZM2.92 13.9999H2V13.0799L9.06 6.01994L9.98 6.93994L2.92 13.9999Z"
      fillRule="evenodd"
      key="PencilEdit2"
    />,
    <path d="M12 12L8 16H18V12H12Z" key="PencilEdit3" />,
  ],
})
